export default "__VITE_ASSET__D9FMLa7y__"